/**
 * Alpine.js Component Registry
 * 
 * All Alpine components are registered here via Alpine.data().
 * This enforces a clear pattern:
 *   1. Each component lives in its own file under /js/alpine/
 *   2. Each component exports a factory function
 *   3. This file imports and registers all of them
 *   4. HTML only references the component NAME: data-x-data="mobileMenu"
 *      (no inline logic in HTML — ever)
 *
 * To add a new component:
 *   1. Create /js/alpine/my-component.js  (export default function)
 *   2. Import it below
 *   3. Register it with Alpine.data('myComponent', myComponent)
 *   4. Use data-x-data="myComponent" in your Razor view
 */
import accordion from './accordion.js';
import mobileMenu from './mobile-menu.js';
import navDropdown from './nav-dropdown.js';
import priorityPlusNav from './priority-plus-nav.js';
import readMore from './read-more.js';
import filterSelect from './filter-select.js';
import socialShare from './social-share.js';
import stickyScrollNav from './sticky-scroll-nav.js';

document.addEventListener('alpine:init', () => {
    // Use data-x- prefix so attributes are valid data-* HTML attributes.
    // The colons in data-x-on:click, data-x-bind:class etc. still fail
    // validation, but this is an accepted tradeoff shared by every
    // declarative JS framework (Vue v-on:, @click, :class are the same).
    Alpine.prefix('data-x-');

    // ── Component registrations ──────────────────────────────────
    Alpine.data('accordion', accordion);
    Alpine.data('mobileMenu', mobileMenu);
    Alpine.data('navDropdown', navDropdown);
    Alpine.data('priorityPlusNav', priorityPlusNav);
    Alpine.data('readMore', readMore);
    Alpine.data('filterSelect', filterSelect);
    Alpine.data('socialShare', socialShare);
    Alpine.data('stickyScrollNav', stickyScrollNav);

    // ── Shared stores (uncomment when needed) ────────────────────
    // Alpine.store('ui', { popupOpen: false });
});
